<template>
  <div class="org-switcher" v-if="organizations && organizations.length > 0">
    <div class="org-switcher-current" @click="isOpen = !isOpen">
      <div class="org-info">
        <span class="org-name">{{ activeOrgName }}</span>
        <span class="org-role">{{ activeOrgRole }}</span>
      </div>
      <svg class="chevron" :class="{ open: isOpen }" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </div>
    <div class="org-switcher-dropdown" v-if="isOpen">
      <div
        class="org-option"
        v-for="org in organizations"
        :key="org.organization.organizationId"
        :class="{ active: org.organization.organizationId === activeOrganizationId }"
        @click="switchOrg(org.organization.organizationId)"
      >
        <span class="org-option-name">{{ org.organization.name }}</span>
        <span class="org-option-role">{{ org.role }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'org-switcher',
  props: {
    organizations: {
      type: Array,
      default: () => [],
    },
    activeOrganizationId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    activeOrg() {
      if (!this.organizations || !this.activeOrganizationId) return null;
      return this.organizations.find(
        (o) => o.organization.organizationId === this.activeOrganizationId,
      );
    },
    activeOrgName() {
      return this.activeOrg ? this.activeOrg.organization.name : '—';
    },
    activeOrgRole() {
      return this.activeOrg ? this.activeOrg.role : '';
    },
  },
  methods: {
    closeOnOutsideClick(e) {
      if (this.$el && !this.$el.contains(e.target)) {
        this.isOpen = false;
      }
    },
    switchOrg(organizationId) {
      this.isOpen = false;
      if (organizationId === this.activeOrganizationId) return;
      this.$emit('switch', organizationId);
    },
  },
  mounted() {
    document.addEventListener('click', this.closeOnOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeOnOutsideClick);
  },
};
</script>

<style lang="sass" scoped>
.org-switcher
  margin: 0 18px 16px
  position: relative

.org-switcher-current
  display: flex
  align-items: center
  justify-content: space-between
  padding: 12px 16px
  border-radius: 8px
  background-color: $primary70
  cursor: pointer
  transition: background-color 0.15s

  &:hover
    background-color: $primary50

.org-info
  display: flex
  flex-direction: column
  overflow: hidden
  min-width: 0

.org-name
  color: $white
  font-size: 0.85rem
  font-weight: 600
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis

.org-role
  color: $primary20
  font-size: 0.7rem
  text-transform: uppercase
  margin-top: 2px

.chevron
  color: $primary20
  flex-shrink: 0
  margin-left: 8px
  transition: transform 0.15s

  &.open
    transform: rotate(180deg)

.org-switcher-dropdown
  position: absolute
  top: calc(100% + 4px)
  left: 0
  right: 0
  background-color: $primary80
  border-radius: 8px
  overflow: hidden
  z-index: 100
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3)

.org-option
  display: flex
  align-items: center
  justify-content: space-between
  padding: 10px 16px
  cursor: pointer
  transition: background-color 0.15s

  &:hover
    background-color: $primary50

  &.active
    background-color: $primary70

.org-option-name
  color: $white
  font-size: 0.8rem
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis

.org-option-role
  color: $primary20
  font-size: 0.65rem
  text-transform: uppercase
  flex-shrink: 0
  margin-left: 8px
</style>
